<template>
  <div
    class="odd:bg-gray-100 border rounded px-4 flex-1 text-sm"
    :class="[focus ? 'border-gray-700' : 'border-gray-200']"
  >
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-1 px-4 space-y-2">
            <h5 class="font-normal text-sm">
              {{ task.title || 'no title' }}
            </h5>
          </div>
          <div class="w-48 px-4">
            {{ project ? project.name : '---' }}
          </div>
          <div class="w-48 px-4">
            {{ assignee ? assignee.fullName : 'not assigned' }}
          </div>
          <div class="w-48 px-4">
            {{ account ? account.name : 'account not found' }}
          </div>
          <div class="w-32 px-4 capitalize">
            {{ task.status }}
          </div>
          <div class="w-32 px-4">
            {{ task.dueAt }}
          </div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <button
          :disabled="disabled"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
          @click="showModal"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    task: { type: Object, required: true },
    focus: Boolean,
    disabled: Boolean,
  },

  computed: {
    ...mapState('entities', {
      account({ accounts }) {
        return accounts.byId[this.task.accountUuid] || null;
      },
      assignee({ users }) {
        if (!this.task.userAssignedId) {
          return undefined;
        }

        return users.byId[this.task.userAssignedId];
      },
      project({ projects }) {
        if (!this.task.projectId && !this.task.project) {
          return undefined;
        }

        return projects.byId[this.task.projectId || this.task.project];
      },
    }),
  },

  methods: {
    showModal() {
      this.$emit('selected-task', this.task.uuid);
      this.$modal.show({
        component: 'ProjectTaskModal',
        props: {
          taskId: this.task.uuid,
        },
        on: {},
        hideEvent: 'task-modal:closed',
      });
    },
  },
};
</script>
